import styled from 'styled-components'
import { Text } from 'vvs-uikit'

export const GradientsFont = styled(Text)<{ title: string }>`
  color: #4799cc;
  position: relative;
  white-space: nowrap;
  &:before {
    position: absolute;
    content: '${({ title }) => title}';
    z-index: 10;
    color: #ffd600;
    -webkit-mask: linear-gradient(to left, #4799cc, transparent);
  }
`
